<template>
  <div class="default-jobs" @click="changeJobs()">
    <div class="jobs">
      <div class="position">
        {{ (!isSelf ? currentApplicant.fullName + ' | ' : '') + currentUserSelectJob.mainText }}
      </div>
      <div class="default-text" v-if="currentUserSelectJob.docDefault">
        {{ $t('global-1.key155', { cm: '默认' }) }}
      </div>
    </div>
    <div class="company">
      {{ currSelectJob }}
    </div>
    <div class="change-job">{{ $t('main-1.key116', { cm: '切换' }) }}</div>
  </div>
</template>

<script>
import { customDepartmentName } from 'service/job';

export default {
  name: 'default-jobs',
  mixins: [],
  props: {
    currentApplicant: {
      type: Object,
      default() {
        return {};
      },
    },
    currentUserSelectJob: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isSelf: true,
    };
  },
  computed: {
    //业务页面当前选人的岗位
    currSelectJob() {
      let seljob = this.currentUserSelectJob;
      return (
        customDepartmentName(seljob.departmentName, seljob.departmentPath, '-') +
        '-' +
        seljob.companyName +
        (seljob.duty ? '-' + seljob.duty : '') +
        (seljob.rank ? '-' + seljob.rank : '')
      );
    },
  },
  watch: {},
  methods: {
    changeJobs() {
      this.$emit('changeDefaultJob');
    },
  },
  mounted() {},
  components: {},
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';
.default-jobs {
  position: relative;
  //padding: px(30) px(40);
  padding: px(12) px(24);
  margin: 0 32px 40px 32px;
  background: #f8f8f8;
  text-align: left;
  border-radius: 12px;

  .jobs {
    font-family: PingFangSC-Regular;
    font-size: px(28);
    color: #505564;
    letter-spacing: 0;
    line-height: px(32);
    display: flex;
    width: 85%;

    .position {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .default-text {
      padding: px(2) px(10);
      background: #e9e9e9;
      border-radius: 4px;
      font-family: PingFangSC-Regular;
      font-size: px(22);
      color: #8c96b4;
      letter-spacing: 0;
      line-height: px(32);
      margin-left: px(10);
      white-space: nowrap;
    }
  }

  .company {
    margin-top: px(16);
    margin-right: px(75);
    font-family: PingFangSC-Regular;
    font-size: px(24);
    color: #8c96b4;
    line-height: px(24);
  }

  .change-job {
    position: absolute;
    right: px(40);
    top: 0;
    font-family: PingFangSC-Regular;
    font-size: px(28);
    color: #505564;
    line-height: px(100);
  }
}
</style>
